import { BrandMark } from "./BrandMark.tsx";
import { Glass } from "./Glass.tsx";
import { GITHUB_REPO_URL, SITE_NAME } from "../lib/site.ts";

const navLink =
  "rounded-full px-3 py-1.5 text-sm text-muted-foreground transition-colors duration-150 hover:bg-muted/40 hover:text-foreground";

export function SiteHeader() {
  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-40 px-3 pt-3 sm:px-4 sm:pt-4">
      <header className="pointer-events-auto relative mx-auto h-14 w-full max-w-6xl rounded-2xl">
        <div aria-hidden="true" className="absolute inset-0">
          <Glass className="h-full rounded-2xl border border-border/50 shadow-lg shadow-black/10" />
        </div>
        <div className="relative z-10 flex h-full items-center gap-3 px-3 sm:gap-4 sm:px-4">
          <a
            href="/"
            aria-label={`${SITE_NAME} — 首页`}
            className="flex shrink-0 items-center gap-2.5 text-foreground transition-opacity duration-150 hover:opacity-80"
          >
            <BrandMark className="size-7" />
            <span className="text-[15px] font-semibold tracking-tight">{SITE_NAME}</span>
          </a>
          <nav className="ml-auto hidden items-center gap-0.5 sm:flex">
            <a href="#features" className={navLink}>
              功能
            </a>
            <a href="#why" className={navLink}>
              为什么
            </a>
            <a href="#pricing" className={navLink}>
              价格
            </a>
            <a
              href={GITHUB_REPO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={navLink}
            >
              GitHub
            </a>
            <a href="#download" className={navLink}>
              下载
            </a>
          </nav>
          <a
            href="#download"
            className="ml-auto inline-flex h-9 items-center gap-2 rounded-full bg-primary px-4 text-sm font-medium text-primary-foreground shadow-sm transition-transform duration-150 hover:-translate-y-px active:translate-y-0 sm:ml-0"
          >
            下载官方版
          </a>
        </div>
      </header>
    </div>
  );
}
